<template>
  <v-tooltip location="end" color="secondary-800">
    <template #activator="{ props: tooltipProps }">
      <!--TODO: сформировать читаемый v-bind для всех параметров и удалить лишние атрибуты-->
      <v-hover v-slot="{ isHovering, props: hoverProps }">
        <v-list-item
          exact
          :class="[
            'min-height-auto pa-2 rounded-lg overflow-hidden',
            {
              'px-0 justify-center': isMiniSidebarShown,
              'active-item': isActiveLink,
              'hover-item': !isActiveLink && !isMobile && isHovering
            }
          ]"
          :to="isActiveLink ? undefined : isPageComputed"
          :href="isReferenceComputed"
          :target="isTargetComputed"
          :ripple="false"
          v-bind="itemProps(tooltipProps, hoverProps)"
          @click="sendNavigationGtmEvent()"
        >
          <template #prepend>
            <div
              v-if="menuItem.icon"
              :class="['justify-center align-center my-0', isMiniSidebarShown ? 'pl-5' : 'mr-3']"
            >
              <c-icon size="20" :name="menuItem.icon" color="white" />
            </div>
          </template>
          <template v-if="!isMiniSidebarShown" #title>
            <div class="d-flex align-center justify-space-between text-white">
              {{ menuItem.text }}
            </div>
          </template>
        </v-list-item>
      </v-hover>
    </template>

    <span>{{ menuItem.text }}</span>
  </v-tooltip>
</template>

<script>
  import { mergeProps } from 'vue'
  import { mapState } from 'pinia'
  import { useSettingsStore } from '@/store/settings/settings'
  import { gtmEvents } from '@clickadilla/components/constants'
  import { CIcon } from '@clickadilla/components/components'
  import gtmPush from '@/services/utils/gtm-push'

  export default {
    name: 'IterableSidebarItem',
    components: { CIcon },
    props: {
      menuItem: {
        type: Object,
        default: () => ({})
      }
    },
    computed: {
      ...mapState(useSettingsStore, ['isMiniSidebarShown']),
      isMobile() {
        return this.$vuetify.display.xs
      },
      isActiveLink() {
        return this.menuItem.activeOn && this.menuItem.activeOn.includes(this.$route.name)
      },
      isTargetComputed() {
        return this.menuItem.href && '_blank'
      },
      isPageComputed() {
        if (this.menuItem.href) return ''

        return this.menuItem.page && { name: this.menuItem.page }
      },
      isReferenceComputed() {
        return this.menuItem.href
      },
      navigationPath() {
        if (this.menuItem.href) return this.menuItem.href
        if (!this.menuItem.page) return ''

        return this.$router.resolve({ name: this.menuItem.page }).path
      }
    },
    methods: {
      itemProps(tooltipProps, hoverProps) {
        return mergeProps(this.isMiniSidebarShown ? tooltipProps : {}, hoverProps)
      },
      sendNavigationGtmEvent() {
        gtmPush({
          event: gtmEvents.SIDEBAR_NAVIGATION_MENU,
          path: this.navigationPath
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .min-height-auto {
    min-height: auto;
  }

  .v-list-item {
    color: rgb(var(--v-theme-secondary-800)) !important;

    &:active {
      background-color: rgb(var(--v-theme-secondary-800)) !important;
    }
  }
  .active-item.v-list-item {
    background-color: rgb(var(--v-theme-secondary-800));
  }

  .hover-item {
    background-color: color-mix(in srgb, rgb(var(--v-theme-secondary-800)) 60%, transparent);
  }

  :deep(.v-list-item__overlay) {
    display: none;
  }
</style>
